/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Box } from "@material-ui/core";
import { useI18n } from "hooks/i18n/i18n";

import type { FC } from "react";

export const PurchasingModal: FC = () => {
  const { t } = useI18n();

  return (
    <Box
      position={"absolute"}
      top={0}
      bottom={0}
      left={0}
      right={0}
      zIndex={"10000"} // 動画プレイヤーより上
    >
      {/* 画面全体を覆う背景 */}
      <Box
        position={"fixed"}
        top={0}
        left={0}
        width={"100%"}
        height={"100%"}
        bgcolor={"rgba(0, 0, 0, 0.16)"}
      />
      <Box
        position={"relative"}
        top={"50%"}
        left={"50%"}
        width={"90%"}
        padding={"16px"}
        textAlign={"center"}
        bgcolor={"#fff"}
        borderRadius={"16px"}
        css={css`
          transform: translate(-50%, -50%);
        `}
      >
        <Box marginBottom={"8px"} fontSize={"16px"} fontWeight={"700"}>
          <Box>{t("streaming.purchasingModal.heading")}</Box>
          <Box>{t("streaming.purchasingModal.subHeading")}</Box>
        </Box>

        <Box component={"p"} fontSize={"14px"} lineHeight={"1.5em"}>
          {t("streaming.purchasingModal.caution")}
        </Box>
      </Box>
    </Box>
  );
};
